import {
  useSetConversation,
  useUpdateConversation,
  useGetConversationById,
} from '../lruConversation';
import { useMemoizedFn } from 'ahooks';

export const useConversationOfId = (id: Conversation.Conversation['conversationId']) => {
  const getConversationById = useGetConversationById();
  return getConversationById(id);
};

type UpdateValue<T> = {
  [K in keyof T]?: T[K];
};

// conversationId 参数兼容旧的代码
export const useUpdateConversationOfId = (id?: Conversation.ConversationId) => {
  const updateConversation = useUpdateConversation();
  const setConversation = useSetConversation();
  const getConversationById = useGetConversationById();

  return useMemoizedFn(function updater<T extends Conversation.Conversation>(
    newValue: UpdateValue<T>,
    conversationId?: Conversation.ConversationId,
  ) {
    const cId = id || conversationId;
    if (cId) {
      const conversation = getConversationById(cId);
      if (conversation) {
        updateConversation(cId, {
          ...conversation,
          ...newValue,
        });
      } else {
        setConversation(cId, newValue as Conversation.Conversation);
      }
    }
  });
};
